import {useGetExperienceVetting} from '@/features/experience-vetting/queries/useGetExperienceVetting.ts'
import {ExpVettingVersionsSelect} from '../exp-vetting-versions-select/ExpVettingVersionsSelect'

export const ExpVettingHeaderEndSlot = ({experienceId}: {experienceId: number}) => {
    const {data} = useGetExperienceVetting(experienceId)
    return <div>{data && <ExpVettingVersionsSelect experienceId={experienceId} />}</div>
}
